import { z } from 'zod';
import { baseScheme, baseSchemeDefaultValue } from './baseScheme';
import { InviteFlowFields } from '../../../consts';

export const accountantScheme = baseScheme.extend({
  [InviteFlowFields.ACCOUNTANT_VIEWER_TERMS]: z.boolean().refine((v) => v),
  [InviteFlowFields.FIRST_NAME]: z.string().optional(),
  [InviteFlowFields.LAST_NAME]: z.string().optional(),
});
export const accountantSchemeDefaultValue = {
  ...baseSchemeDefaultValue,
  [InviteFlowFields.ACCOUNTANT_VIEWER_TERMS]: false,
};
